import { Navigate } from 'react-router-dom';
import { useBusinessStore } from '@/store/businessStore';

/**
 * The posting schedule is per-business, so the old global /schedule-settings
 * page is gone. Keep the URL working for bookmarks: send the user to the
 * selected business's Schedule tab, or to the business list to pick one.
 */
export default function ScheduleSettingsRedirect() {
  const businessId = useBusinessStore((s) => s.currentBusinessId);

  return businessId
    ? <Navigate to={`/businesses/${businessId}/settings?section=schedule`} replace />
    : <Navigate to="/businesses" replace />;
}
